<template>
    <DialogLayout>
        <Menu v-if="view === 'menu'" @setView="setView"/>
        <EditProfileModal v-if="view === 'profile'" @setView="setView"/>
        <EditEmail v-if="view === 'email'" @setView="setView"/>
        <EditPassword v-if="view === 'password'" @setView="setView"/>
    </DialogLayout>
</template>

<script>

    import Menu from "./Menu";
    import EditProfileModal from "./EditProfile";
    import EditEmail from "./EditEmail";
    import EditPassword from "./EditPassword";
    import ModalBus from "../../../eventBus";
    import DialogLayout from "../Layouts/DialogLayout";

    export default {
        components: {DialogLayout, EditPassword, EditEmail, EditProfileModal, Menu},
        data: function () {
            return {
                view: 'menu'
            }
        },
        methods: {
            setView: function (view) {
                this.view = view;
            }
        },
        created(){
            ModalBus.$on('closed', () => this.setView('menu'));
        }
    }
</script>
